var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 123,
    viewBox: "0 0 124 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4440_10800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 123
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.950195 0H123.05V122.1H0.950195V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4440_10800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.178 54.5621C110.734 79.8605 93.648 102.534 68.3496 106.09C43.0512 109.645 20.3773 92.5593 16.8219 67.2609C13.2664 41.9625 30.3524 19.2886 55.6508 15.7332C80.9492 12.1777 103.623 29.2637 107.178 54.5621Z",
    stroke: "#2ACD24",
    strokeWidth: 0.102294,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8049 98.5111C38.4569 95.2926 26.3108 82.881 23.9743 66.2558C20.9817 44.9623 35.3628 25.8779 56.6563 22.8853C77.9498 19.8927 97.0343 34.2738 100.027 55.5673C103.019 76.8608 88.6383 95.9452 67.3448 98.9379C62.6765 99.5939 58.1147 99.415 53.8049 98.5111Z",
    stroke: "#2ACD24",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.255 55.3911C105.377 77.6075 89.8739 98.1806 67.6575 101.303C45.4411 104.425 24.8681 88.9223 21.7458 66.7059C18.6234 44.4895 34.1264 23.9164 56.3428 20.7941C78.5592 17.6718 99.1322 33.1747 102.255 55.3911Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.116 55.2544C105.239 77.4708 89.7358 98.0439 67.5194 101.166C45.303 104.288 24.7299 88.7856 21.6076 66.5692C18.4853 44.3528 33.9882 23.7797 56.2046 20.6574C78.421 17.5351 98.9941 33.038 102.116 55.2544Z",
    fill: "#2ACD24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1006 61.8784L52.4084 75.5794L83.9006 47.5498",
    stroke: "#179337",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1006 61.8784L52.4084 75.5794L83.9006 47.5498",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4751a62c77b2a90b0424fed57d3d1741.svg";
export { ForwardRef as ReactComponent };